import { animate, motion } from "framer-motion";
import styles from "./AnimatedText.module.scss";
import { framerAnim } from "utilities/framer";

type AnimatedTextProps = {
  text: string;
  el?: keyof JSX.IntrinsicElements;
  className?: string;
  once?: boolean;
};

export default function AnimatedText({
  text,
  el: Wrapper = "p",
}: AnimatedTextProps) {
  const textAnimation = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
  };

  return (
    <Wrapper className={styles.wrapper}>
      <motion.span
        className={styles.textWrapper}
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.1 }}
      >
        {text.split(" ").map((word, i) => (
          <span key={i}>
            {word.split("").map((char, k) => (
              <motion.span
                {...framerAnim(textAnimation)}
                className={styles.char}
                key={k}
              >
                {char}
              </motion.span>
            ))}
            <span>&nbsp;</span>
          </span>
        ))}
      </motion.span>
    </Wrapper>
  );
}
